export const creativeFormMixin = {
  methods: {
    setShowDevice(device) {
      this.show_device = device;
      if (device == "both") {
        this.$store.commit("creative/setPreviewListShowPc", true);
        this.$store.commit("creative/setPreviewListShowSp", true);
        this.$store.commit("creative/setPreviewListImage", '');
        this.$store.commit("creative/setPreviewListUploadImage", '');
        this.$store.commit("creative/setPreviewListPcImage", '');
        this.$store.commit("creative/setPreviewListUploadPcImage", '');
        this.$store.commit("creative/setPreviewListCommonImage", '');
        this.$store.commit("creative/setPreviewListUploadCommonImage", '');
        this.$store.commit("creative/setPreviewListIsUploadCommonImage", 1);
        this.$store.commit("creative/setPreviewUploadImagePath", '');
        this.$store.commit("creative/setPreviewUploadPcImagePath", '');
      } else if (device == "pc") {
        this.$store.commit("creative/setPreviewListShowPc", true);
        this.$store.commit("creative/setPreviewListShowSp", false);
        this.$store.commit("creative/setPreviewListImage", '');
        this.$store.commit("creative/setPreviewListUploadImage", '');
        this.$store.commit("creative/setPreviewListPcImage", '');
        this.$store.commit("creative/setPreviewListUploadPcImage", '');
        this.$store.commit("creative/setPreviewListCommonImage", '');
        this.$store.commit("creative/setPreviewListUploadCommonImage", '');
        this.$store.commit("creative/setPreviewUploadImagePath", '');
        this.$store.commit("creative/setPreviewUploadPcImagePath", '');
        this.option_image = "same";
      } else if (device == "sp") {
        this.$store.commit("creative/setPreviewListShowPc", false);
        this.$store.commit("creative/setPreviewListShowSp", true);
        this.$store.commit("creative/setPreviewListImage", '');
        this.$store.commit("creative/setPreviewListUploadImage", '');
        this.$store.commit("creative/setPreviewListPcImage", '');
        this.$store.commit("creative/setPreviewListUploadPcImage", '');
        this.$store.commit("creative/setPreviewListCommonImage", '');
        this.$store.commit("creative/setPreviewListUploadCommonImage", '');
        this.$store.commit("creative/setPreviewUploadImagePath", '');
        this.$store.commit("creative/setPreviewUploadPcImagePath", '');
        this.option_image = "same";
      }
    },
    setMaxWidth(val) {
      this.$store.commit('creative/setPreviewListPopUpMaxWidth', String(val));
    },
    updatePopUpAnimation(e) {
      this.$store.commit(
        "creative/setPreviewListPopUpAnimation",
        e.target.value
      );
    },
    setNoLink(e) {
      this.$store.commit("creative/setPreviewListNoLink", e.target.checked);
      // ラジオボタンに変更したため、falseにする処理追加
      this.$store.commit("creative/setPreviewListTargetBlank", false);
      this.$store.commit("creative/setPreviewListInnerLink", false);
    },
    setTargetBlank(e) {
      this.$store.commit("creative/setPreviewListTargetBlank", e.target.checked);
      // ラジオボタンに変更したため、falseにする処理追加
      this.$store.commit("creative/setPreviewListNoLink", false);
      this.$store.commit("creative/setPreviewListInnerLink", false);
    },
    setInnerLink(e) {
      this.$store.commit("creative/setPreviewListInnerLink", e.target.checked);
      // ラジオボタンに変更したため、falseにする処理追加
      this.$store.commit("creative/setPreviewListNoLink", false);
      this.$store.commit("creative/setPreviewListTargetBlank", false);
    },
  }
};
